import SectionLabel from "@/components/SectionLabel";

const values = [
  {
    kicker: "Communion",
    title: "A welcoming home",
    body: "We seek to become a parish where people are received with compassion and where no one feels abandoned.",
    glyph: "✦",
  },
  {
    kicker: "Participation",
    title: "A listening Church",
    body: "Lay leaders, families, youth, GKKs, and ministries called to active service and shared discernment.",
    glyph: "✠",
  },
  {
    kicker: "Mission",
    title: "Going forth",
    body: "Bringing the Gospel beyond the church walls through formation, social action, and care for creation.",
    glyph: "❦",
  },
  {
    kicker: "Simplicity",
    title: "Franciscan witness",
    body: "Walking humbly with the poor — in the spirit of our patron, Saint Francis of Assisi.",
    glyph: "✿",
  },
];

const quotes = [
  {
    text: "Lord, make me an instrument of your peace.",
    by: "St. Francis of Assisi",
  },
  {
    text: "Where there is hatred, let me sow love.",
    by: "Prayer of St. Francis",
  },
  {
    text: "Start by doing what's necessary; then what's possible; and suddenly you are doing the impossible.",
    by: "St. Francis of Assisi",
  },
];

export default function Gallery() {
  return (
    <section id="gallery" className="py-24 md:py-36 bg-parchment-200 relative grain overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,rgba(212,175,55,0.06),transparent_55%)]" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel
          kicker="Spirit of the Parish"
          title="Life of the Community"
          intro="A community shaped by Francis' four marks — communion, participation, mission, and simplicity."
        />

        {/* Value cards */}
        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-parchment-400">
          {values.map((v) => (
            <article
              key={v.kicker}
              className="group bg-parchment-100 p-8 md:p-10 hover:bg-parchment-50 transition-colors duration-500 relative"
            >
              <div className="font-serif text-5xl text-terracotta/70 mb-5 leading-none">
                {v.glyph}
              </div>
              <div className="text-[10px] uppercase tracking-[0.28em] text-sage-dark mb-2 font-sans">
                {v.kicker}
              </div>
              <h3 className="font-serif text-xl md:text-2xl text-cocoa-900 mb-3 leading-tight">
                {v.title}
              </h3>
              <p className="font-sans text-cocoa-800 leading-relaxed font-light text-[15px]">
                {v.body}
              </p>
              <div className="mt-6 h-px w-8 bg-sage group-hover:w-16 transition-all duration-500" />
            </article>
          ))}
        </div>

        {/* Three Franciscan quotes — typographic bento */}
        <div className="mt-16 grid md:grid-cols-12 gap-6">
          <blockquote className="md:col-span-7 bg-cocoa-900 text-parchment-100 p-10 md:p-12 relative overflow-hidden">
            <div className="absolute -top-6 -left-2 font-serif text-[14rem] text-gold/15 leading-none select-none">
              &ldquo;
            </div>
            <p className="relative font-serif italic text-3xl md:text-4xl leading-snug">
              {quotes[0].text}
            </p>
            <footer className="relative mt-6 text-[11px] uppercase tracking-[0.28em] text-gold">
              — {quotes[0].by}
            </footer>
          </blockquote>

          <blockquote className="md:col-span-5 bg-terracotta text-parchment-100 p-10 flex flex-col justify-between">
            <p className="font-serif italic text-2xl leading-snug">
              {quotes[1].text}
            </p>
            <footer className="mt-6 text-[11px] uppercase tracking-[0.28em] text-parchment-100/80">
              — {quotes[1].by}
            </footer>
          </blockquote>

          <blockquote className="md:col-span-12 bg-parchment-100 border border-parchment-400 p-10 text-center">
            <p className="font-serif italic text-2xl md:text-3xl text-cocoa-900 leading-snug max-w-3xl mx-auto">
              {quotes[2].text}
            </p>
            <footer className="mt-5 text-[11px] uppercase tracking-[0.28em] text-sage-dark">
              — {quotes[2].by}
            </footer>
          </blockquote>
        </div>
      </div>
    </section>
  );
}
